<template>
  <div>
    <van-popup
      v-model="show"
      class="facedetection12306"
      :get-container="element || ''"
      close-on-popstate
      closeable
      round
    >
      <div class="text-center">
        <van-row>
          <img
            src="~Assets/images/tr/face-verification.png"
            width="94"
            @click="test = !test"
          >
          <!--<van-uploader v-model="fileList" multiple :max-count="1" :max-size="2048 * 1024" @oversize="onOversize"/>-->
        </van-row>

        <h3 style="margin-top: 0;">
          需要完成人证核验
        </h3>

        <van-row class="text-center font12 gray">
          为保障您的账号信息安全，需进行人证核验后才能继续登录购票
        </van-row>

        <!-- <van-row
          class="bg-lightGray font-bold round-md mt12"
          style="padding: 8px;"
        >
          请确认您是账号本人：<span class="main-color">X X X</span>
        </van-row> -->

        <van-row class="mt12">
          <ld-button
            main2
            @click="showDetection = true"
          >
            同意协议并开始核验
          </ld-button>
        </van-row>




        <van-row class="mt12 gray font10">
          开始核验代表已阅读并同意
          <a
            @click="showAgreement = true"
            class="main-color"
            style="text-decoration: underline;"
          >
            认证协议
          </a>
        </van-row>
      </div>
    </van-popup>

    <verificate
      ref="verificate"
      :element="element"
      :user-name="userName"
      :password="password"
      @success="smsSuccessCallback"
    />

    <van-popup
      v-model="showAgreement"
      position="right"
      lock-scroll
      close-on-popstate
      class="full-width full-height"
      :get-container="element || ''"
    >
      <ld-header
        title="面部特征使用协议"
        @click-left="showAgreement = false"
      />

      <pre
        class="pad8 pre-wrap"
        style="line-height: 20px; font-family: auto; margin-top: 0;"
      >
《面部特征使用协议》 （以下简称"本协议"）是由{{ loginConfig.pageName }}（以下统称"我司"或"我们"）与用户（或称"您"）就面部特征使用相关事宜订立的有效合约。请您先仔细阅读并充分理解本协议全部内容，如您对本协议内容及页面提示信息有疑问，请勿进行下一步操作。您可以通过我们的在线客服进行咨询，以便我们为您解释和说明。
您在页面通过点击或其他方式确认本协议或您开始使用我们提供的服务，即表示您已同意本协议，并授权我们在本协议约定范围内使用您提供的面部特征。

一.定义
面部特征：可用以识别自然人个体的独特脸部特征等生物识别信息。
二.使用权限及范围
2.1 使用权限
只有当您自主选择提供基于摄像头（相机）的功能拍摄及认证功能，并同意使用该附加功能进行人脸识别认证时，我们才会使用您提供的面部特征，且严格在经您授权同意的范围内使用。
2.2 使用范围
面部特征将被使用于需要确认身份的应用场景，例如：当您使用我司提供的火车票信息服务向中国铁路12306网站（www.12306.cn，以下简称"铁路官方网站"或"12306"）或授权代售点进行查询、购票、退票、改签、候补等操作时，如您未注册12306账号、未激活12306会员、需注销12306账号、需找回密码或需12306网进一步认证且继续使用服务，则您需提供您的面部特征信息供我们传输至12306代您申请认证核验。
三.权利与义务
3.1 当您通过{{ loginConfig.pageName }}使用铁路官网需要身份确认的服务时，您同意并委托和授权我司使用您本人的面部特征并传输至铁路官方网站为您提供12306账号代为注册和代您申请人证核验等认证服务的便捷服务。您有权拒绝提供您的面部特征信息，当您拒绝后我司不会采集您的面部特征，但请注意铁路官网可能因此拒绝您的使用导致我们无法为您继续提供服务。
3.2 为了提供验证的准确性，您同意铁路官网可在必要时您将提供的脸部特征与法律法规允许的机构或政府机构授权的机构所保存您的脸部特征进行比对核验。
3.3 请您遵守法律法规，不得在使用过程中存在冒用他人身份信息注册，或呈报不实信息，以及利用系统差错、故障或其他漏洞，造成铁路或其他旅客权益受损等行为，否则您将被追究响应的法律责任。如导致铁路官网拒绝提供服务或导致他人损失，您将承担全部责任。
3.4 您必须确保本人信息真实、准确。若存在个人信息错误、不真实等情况，导致12306注册失败、登录障碍、12306会员开通失败、购票失败、无法退改、候补失败的，由您自行承担相关不利后果和损失。因您提供的信息有误而导致您的权益受损等情况，我司不承担任何责任。
3.5 您应遵守铁路官网相关服务条款、须知和政策（详见12306网公示）。您账号注册、密码找回、会员开通、购票、退改、候补等操作成功与否均已12306的信息为准。如您在使用过程中有任何违反铁路官网服务条款、铁路有关规则规定的违规行为，导致铁路官网拒绝服务的，我司不承担任何责任。
3.6 我们重视对您的信息保护，承诺严格保护您的身份资料和脸部特征。我司将依照法律法规与铁路客运规定及其他与您的约定保护您的面部特征信息。
四.免责条款
您同意因下列原因导致无法正常提供服务，我司不承担责任:
4.1 系统停机维护或升级；
4.2 因铁路客运规定、政策变动，或者网络传输误差等原因；
4.3 因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；
4.4 用户的电脑或手机软硬件和通信线路、供电线路出现故障的；
4.5 因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、第三方服务瑕疵等原因。
五.法律
本服务协议要与该国的法律解析一致，包括法律条款中有争议抵触的内容。
六、其他
本协议未尽事宜以我们与您签署的《火车票服务协议》及{{ loginConfig.pageName }}平台内相关协议和规则为准。

      </pre>
    </van-popup>

    <van-popup
      v-model="showDetection"
      position="right"
      close-on-popstate
      lock-scroll
      class="full-width full-height"
      :get-container="element || ''"
    >
      <ld-header
        transparent
        white
        @click-left="showDetection = false"
      >
        <img
          slot="left"
          class="custom-back"
          src="~Assets/images/back.png"
        >
      </ld-header>

      <div class="detectionWarpper">
        <mescroll-vue :down="down">
          <ldFaceDetection
            v-if="showDetection"
            ref="ldFaceDetectionRef"
            :test="test"
            :isTrInvoce="true"
            @invoiceSuccess="faceDetectionSuccessCallback"
            @error="faceDetectionErrorCallback"
          />
        </mescroll-vue>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Search, Popup, Cell, CellGroup, Field,Uploader} from 'vant'
import ldButton from 'Common/ldButton'
import ldFaceDetection from 'Components/ldFaceDetection'
import verificate from '../../../../Tr/trQuery/trEdit/verificate12306.vue'

export default {
  name: 'InvoiceFaceDetection12306',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    ldButton,
    ldFaceDetection,
    verificate,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  props: {
    element:{
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: () => ''
    },
    password: {
      type: String,
      default: () => ''
    },
    register: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      down: { use: false },
      show: false,
      showAgreement: false,
      showDetection: false,
      test: false, // 调试后门
      fileList: [],
    }
  },
  computed: {
    ...mapState({
      loginConfig: state => state.app.loginConfig,
    })
  },
  methods: {
    async verificate (picUrl) {
      try {
        /**
         * 照片路径 多个用逗号拼接，最少一个，
         * 最多两个人脸核验照片限制
         * ①文件大小：100k以内
         * ②像素：150*200像素
         * ③不能带眼镜
         */
        this.$toast.loading({ message: '正在核验中...', duration: 0 })

        var pictureBase64s = picUrl.src
        //pictureBase64s = pictureBase64s.split(',')
        pictureBase64s = pictureBase64s.split(',')
        picUrl = pictureBase64s[1]

        console.log("this.userName {}this.password{}",this.userName,this.password)

        await this.$api['trQuery/rlSb']({
          userName: this.userName,
          password: this.password,
          picUrl: picUrl,
          verifyType: '2'
        })
        this.$toast.success('操作成功')
        this.$emit('success')
      } catch (error) {
        console.log("人脸识别失败，重试")
        this.$toast.fail(error.tips)
        // this.show = true
        throw error
      } finally {
        console.log("this.toggle(")
        this.toggle()
      }
    },
    faceDetectionSuccessCallback (res) {
      console.log('invoice 检测成功：{}',res)
      this.showDetection = false
      this.verificate(res)
    },
    faceDetectionErrorCallback (error) {
      this.$toast.fail(error)
    },
    // 短信验证成功回调
    smsSuccessCallback () {
      this.$toast.success('核验成功')
      this.toggle()
      this.$emit('success')
    },
    toggle() {
      this.show = !this.show
    },
    async uploadFile() {
      console.log('uploadFile 上传图片文件')
      if (this.fileList.length > 0) {
        var file = this.fileList[0].content;
        if (file){
          const fileBase64 = file.split(",")[1];
          console.log("fileBase64{}", fileBase64)
          //await this.verificate(fileBase64)
        }


      }else {
        this.$toast.fail('请先上传需要核验的图片信息')
      }

    },
    onOversize(){
      this.$toast.fail('文件大小不能超过 2M')
    }
  }
}
</script>

<style lang="less">
.facedetection12306 {
  width: 80%;
  background-image: -webkit-linear-gradient(bottom, #eef2f7 70%, @color-background-main 95%) !important;

  padding: 46px 12px 12px;

  .padLR8 {
    padding: 0 8px;
  }

  .mt12 {
    margin-top: 12px;
  }

}

.detectionWarpper {
  height: calc(100vh - 46px);
  overflow: hidden;
}
</style>
